// src/app/services/email.service.ts (o como se llame)
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  // private apiUrl = 'https://beeasy-back.onrender.com/email/send';
  // private apiUrl = 'http://localhost:3000/email/send';
  apiUrl = '';
  apiService = inject(ApiService);

  constructor(private http: HttpClient) {
    this.apiUrl = this.apiService.getApi() + '/email/send';
  }

  sendEmail(to: string, subject: string, html: string) {
    const body = { to, subject, html };
    return this.http.post(this.apiUrl, body);
  }
}
